import { Pipe, PipeTransform } from '@angular/core';
import { isAfter, isBefore, parseISO, isEqual } from 'date-fns';

@Pipe({
    name: 'byToDate',
    standalone: false
})

export class ByToDatePipe implements PipeTransform {

  transform(value: any[], ...args: any): any[] {
    args = args[0];
    if (!value || !args || args.length < 3 || !args[0] || !args[1]) {
      return value;
    }

    const startDate = args[0];
    const endDate = args[1];
    const filterType = args[2];

    return value.filter((item) => {
      let itemDate: Date | undefined;
      try {
        if (filterType === 'or_order_number') {
          itemDate = item?.or_order_date ? parseISO(item.or_order_date) : undefined;
        } else if (filterType === 'ms_datetime') {
          itemDate = item?.ms_datetime ? parseISO(item.ms_datetime) : undefined;
        }
      } catch {
        return true;
      }

      if (!itemDate || isNaN(itemDate.getTime())) {
        return true;
      }

      return (
        (isAfter(itemDate, startDate) || isEqual(itemDate, startDate)) &&
        (isBefore(itemDate, endDate) || isEqual(itemDate, endDate))
      );
    });
  }
  
}
